import React, { Component } from 'react';
import MenuMain from "../../components/frontend/MenuMain";

class Ticket extends Component {

  render() {
    return (<>
      <MenuMain />
      TicketTicketTicketTicketTicketTicketTicket
      
    </>);
  };
}

export default Ticket;
